import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { FormDesignerComponent } from './form-designer.component';
import { SharedModule } from '../shared/shared.module';

// Import the pdf-form-designer module from the submodule
import { PdfFormDesignerModule } from '../../../../libs/form-designer/projects/pdf-form-designer/src/lib/pdf-form-designer.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    SharedModule,
    PdfFormDesignerModule
  ],
  declarations: [FormDesignerComponent],
  exports: [FormDesignerComponent]
})
export class FormDesignerModule { }